export const isTouchDevice =
  typeof window !== "undefined"
    ? "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    : false;
